/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Filled by the model via structured outputs. Units follow the codebase
 * convention (mm/g, like Capture.length_millimeters); fish_present=False is
 * the analog of ServerLengthStatus.NO_FISH — and an independent second
 * opinion where a segmenter already ran.
 * @export
 * @interface SizeEstimate
 */
export interface SizeEstimate {
    /**
     * 
     */
    fishPresent: boolean;
    /**
     * 
     */
    estimable: boolean;
    /**
     * 
     */
    lengthMm: number | null;
    /**
     * 
     */
    girthMm: number | null;
    /**
     * 
     */
    weightG: number | null;
    /**
     * 
     */
    confidence: SizeEstimateConfidenceEnum;
    /**
     * 
     */
    basis: string;
    /**
     * 
     */
    speciesScientific?: string | null;
    /**
     * 
     */
    speciesCommon?: string | null;
}


/**
 * @export
 */
export const SizeEstimateConfidenceEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high',
} as const;
export type SizeEstimateConfidenceEnum = typeof SizeEstimateConfidenceEnum[keyof typeof SizeEstimateConfidenceEnum];


/**
 * Check if a given object implements the SizeEstimate interface.
 */
export function instanceOfSizeEstimate(value: object): value is SizeEstimate {
    if ((!('fishPresent' in (value as Record<string, any>)) && !('fish_present' in (value as Record<string, any>))) || ((value as Record<string, any>)['fishPresent'] === undefined && (value as Record<string, any>)['fish_present'] === undefined)) return false;
    if (!('estimable' in value) || value['estimable'] === undefined) return false;
    if ((!('lengthMm' in (value as Record<string, any>)) && !('length_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMm'] === undefined && (value as Record<string, any>)['length_mm'] === undefined)) return false;
    if ((!('girthMm' in (value as Record<string, any>)) && !('girth_mm' in (value as Record<string, any>))) || ((value as Record<string, any>)['girthMm'] === undefined && (value as Record<string, any>)['girth_mm'] === undefined)) return false;
    if ((!('weightG' in (value as Record<string, any>)) && !('weight_g' in (value as Record<string, any>))) || ((value as Record<string, any>)['weightG'] === undefined && (value as Record<string, any>)['weight_g'] === undefined)) return false;
    if (!('confidence' in value) || value['confidence'] === undefined) return false;
    if (!('basis' in value) || value['basis'] === undefined) return false;
    return true;
}

export function SizeEstimateFromJSON(json: any): SizeEstimate {
    return SizeEstimateFromJSONTyped(json, false);
}

export function SizeEstimateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SizeEstimate {
    if (json == null) {
        return json;
    }
    return {
        
        'fishPresent': json['fish_present'],
        'estimable': json['estimable'],
        'lengthMm': json['length_mm'],
        'girthMm': json['girth_mm'],
        'weightG': json['weight_g'],
        'confidence': json['confidence'],
        'basis': json['basis'],
        'speciesScientific': json['species_scientific'] === undefined ? undefined : json['species_scientific'] === null ? null : json['species_scientific'],
        'speciesCommon': json['species_common'] === undefined ? undefined : json['species_common'] === null ? null : json['species_common'],
    };
}

export function SizeEstimateToJSON(json: any): SizeEstimate {
    return SizeEstimateToJSONTyped(json, false);
}

export function SizeEstimateToJSONTyped(value?: SizeEstimate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fish_present': value['fishPresent'],
        'estimable': value['estimable'],
        'length_mm': value['lengthMm'],
        'girth_mm': value['girthMm'],
        'weight_g': value['weightG'],
        'confidence': value['confidence'],
        'basis': value['basis'],
        'species_scientific': value['speciesScientific'],
        'species_common': value['speciesCommon'],
    };
}

